import { z } from "zod";

import { useModelsCollection } from "../../../api/firestoreWrappers.generated.jsx";
import ReactSelectFormGroup from "../../FormGroups/ReactSelectFormGroup.jsx";

export const ModelRunnerSettingsSchema = z.object({
    model_runner: z
        .object({
            models: z.array(z.string()).optional(),
        })
        .optional(),
});

export const ModelRunnerSettingsValues = (settings) => ({
    model_runner: {
        models: settings?.model_runner?.models ?? [],
    },
});

export default function ModelRunnerSettingsFormFields({
    control,
    errors,
    setValue,
    defaultAppSettings,
}) {
    const [models] = useModelsCollection();

    const modelLookup = Object.fromEntries(
        models.map((model) => [
            model.id,
            `${model.name} ${model.version || "1.0"}`,
        ]),
    );
    const defaultModelNames = defaultAppSettings?.model_runner?.models
        ?.map((id) => modelLookup[id] || id)
        ?.join(", ");
    return (
        <>
            <h4>Model runner</h4>
            <ReactSelectFormGroup
                label="Models"
                name="settings.model_runner.models"
                options={models.map((model) => {
                    return {
                        id: model.id,
                        name: `${model.name} ${model?.version || "1.0"}`,
                    };
                })}
                isMulti={true}
                control={control}
                errors={errors}
                setValue={setValue}
                defaultValue={defaultAppSettings ? [] : undefined}
                placeholder={
                    defaultAppSettings
                        ? defaultAppSettings?.model_runner?.models != null
                            ? `Leave empty to use default: ${defaultModelNames}`
                            : "Leave empty to ignore"
                        : undefined
                }
            />
        </>
    );
}
